import React, { Children, isValidElement } from 'react';

import { PaneContentWrapper } from './PaneContentWrapper';

interface PaneSelectorProps {
  activePaneId: string;
  children: React.ReactNode;
}

export const PanesContentSelector = ({ children, activePaneId }: PaneSelectorProps) => {
  const childArray = Children.map(children, (child: React.ReactNode) => {
    if (isValidElement(child) && child.type === PaneContentWrapper) {
      return { paneId: child.props.paneId, child };
    }
    return null;
  });

  const activePaneElement = childArray?.find((child: any) => child.paneId === activePaneId)?.child || null;

  return <>{activePaneElement}</>;
};
